import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=ef72972a"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef72972a')) {
      api.createRecord('ef72972a', component.options)
    } else {
      api.reload('ef72972a', component.options)
    }
    module.hot.accept("./Comment.vue?vue&type=template&id=ef72972a", function () {
      api.rerender('ef72972a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/example/components/Dropdown/Comment.vue"
export default component.exports